/**
 * English UI strings.
 *
 * This file is the source of truth for the key set: `as.ts` is typed against it, and
 * `npm run check:i18n` fails the build if the two diverge. Keys are flat and dotted,
 * grouped by surface. Never concatenate translated fragments — add a whole key instead.
 */
export const en = {
    'brand.mark': 'NK',
    'brand.name': 'NEWS TIME',
    'brand.tagline': 'A STRONGER ASSAM',
    'nav.home': 'HOME',
    'nav.state': 'STATE',
    'nav.national': 'NATIONAL',
    'nav.local': 'LOCAL',
    'nav.sports': 'SPORTS',
    'nav.health': 'HEALTH',
    'nav.jobs': 'JOBS',
    'nav.entertainment': 'ENTERTAINMENT',
    'nav.videos': 'VIDEOS',
    'nav.menu': 'Menu',
    'nav.close': 'Close',
    'ticker.label': 'BREAKING',
    'ticker.quiet': 'No breaking news right now.',
    'action.liveTv': 'LIVE TV',
    'action.readFullStory': 'READ FULL STORY',
    'action.viewAll': 'VIEW ALL',
    'action.viewAllNews': 'VIEW ALL NEWS',
    'action.viewAllTrending': 'VIEW ALL TRENDING',
    'action.viewAllUpdates': 'VIEW ALL UPDATES',
    'action.search': 'Search',
    'action.share': 'Share',
    'action.retry': 'Try again',
    'action.backToTop': 'Back to top',
    'action.switchLanguage': 'অসমীয়াত পঢ়ক',
    'section.featured': 'FEATURED',
    'section.topStory': 'TOP STORY',
    'section.categories': 'Explore by Category',
    'section.latest': 'Latest & Important',
    'section.trending': 'Trending Now',
    'section.liveUpdates': 'LIVE UPDATES',
    'section.videos': 'Videos',
    'video.indexBlurb': 'Reports, interviews and Shorts from the NK News Time desk.',
    'video.filterLabel': 'Filter videos by category',
    'video.shorts': 'Shorts',
    'video.short': 'Short',
    'video.related': 'More videos',
    'video.fromStory': 'From this story',
    'video.none': 'No videos here yet.',
    'video.unavailable': 'This video is no longer available.',
    'video.watchOnArticle': 'Watch',
    'section.videoCoverage': 'Video Coverage',
    'section.culture': 'CULTURE',
    'newsletter.title': 'Stay Informed',
    'newsletter.body': 'Get the latest news updates directly in your inbox.',
    'newsletter.placeholder': 'Enter your email address',
    'newsletter.submit': 'SUBSCRIBE',
    'meta.readTime': '{minutes} MIN READ',
    'meta.justNow': 'JUST NOW',
    'meta.advertisement': 'ADVERTISEMENT',
    'footer.quickLinks': 'QUICK LINKS',
    'footer.categories': 'CATEGORIES',
    'footer.localNews': 'LOCAL NEWS',
    'footer.legal': 'LEGAL',
    'footer.contact': 'CONTACT US',
    'footer.rights': 'All Rights Reserved.',
    'footer.madeIn': 'Made with ❤ in Assam',
    'error.notFoundTitle': 'Page not found',
    'error.notFoundBody': 'The page you are looking for may have moved or no longer exists.',
    'error.genericTitle': 'Something went wrong',
    'error.genericBody': 'Please try again in a moment.',
    'error.offline': 'You are offline. Showing the last loaded content.',
    'action.loadMore': 'LOAD MORE',
    'action.previous': 'Previous',
    'action.next': 'Next',
    'action.skipToContent': 'Skip to content',
    'search.title': 'Search',
    'search.placeholder': 'Search news…',
    'share.copyLink': 'Copy link',
    'share.copied': 'Link copied',
    'status.loading': 'Loading…',
    'status.comingIn': 'This section is filled in phase {phase}.',
    'footer.about': 'ABOUT US',
    'footer.privacy': 'PRIVACY POLICY',
    'footer.terms': 'TERMS OF USE',
    'footer.advertise': 'ADVERTISE',
    'action.previousSlide': 'Previous story',
    'action.nextSlide': 'Next story',
    'action.play': 'Play video',
    'filter.all': 'ALL',
    'empty.noStories': 'No stories here yet.',
    'live.now': 'LIVE NOW',
    'live.none': 'No live coverage right now.',
    'live.updateCount': '{count} updates',
    'live.statusScheduled': 'Starting soon',
    'live.statusLive': 'Live',
    'live.statusEnded': 'Coverage ended',
    'live.statusArchived': 'Archived',
    'live.startsAt': 'Starts {time}',
    'live.startedAt': 'Started {time}',
    'live.endedAt': 'Ended {time}',
    'live.timeline': 'Updates',
    'live.keyUpdate': 'Key update',
    'live.newUpdates': '{count} new updates',
    'live.newUpdate': '1 new update',
    'live.olderUpdates': 'Older updates',
    'live.noUpdates': 'No updates posted yet. This page will fill itself as they arrive.',
    'live.readMore': 'Read the full story',
    'realtime.reconnecting': 'Reconnecting…',
    'realtime.polling': 'Live connection lost — checking every 30 seconds',
    'article.breaking': 'Breaking news',
    'share.more': 'More sharing options',
    'action.print': 'Print',
    'action.bookmark': 'Bookmark',
    'article.related': 'Related stories',
    'article.moreFromAuthor': 'More from this reporter',
    'article.updated': 'Updated {date}',
    'search.category': 'Category',
    'search.district': 'District',
    'search.filters': 'Filters',
    'search.author': 'Author',
    'search.dateRange': 'Date range',
    'search.dateFrom': 'From',
    'search.dateTo': 'To',
    'search.sort': 'Sort by',
    'search.sort.relevance': 'Relevance',
    'search.sort.newest': 'Newest first',
    'search.sort.most_viewed': 'Most read',
    'search.recent': 'RECENT SEARCHES',
    'search.clearRecent': 'Clear',
    'search.clearFilters': 'Clear filters',
    'search.resultCount': '{count} results for “{query}”',
    'search.emptyTitle': 'Nothing found for “{query}”',
    'search.emptyBody': 'Try fewer words, or a different spelling.',
    'search.promptTitle': 'Search NK News Time',
    'search.promptBody': 'Type a word or two — headlines, tags and article text are all searched.',
    'footer.blurb': 'A stronger Assam — reporting from Assam, India and the wider world.',
    // --- Admin CMS (Phase 14) ---------------------------------------------------
    // §1.15: "the admin CMS is itself bilingual and defaults to the user's
    // preferred_locale", so every string an editor reads lives here too.
    'admin.brand': 'Newsroom',
    'admin.dashboard': 'Dashboard',
    'admin.content': 'Content',
    'admin.articles': 'Articles',
    'admin.media': 'Media',
    'admin.videos': 'Videos',
    'admin.editorial': 'Editorial',
    'admin.homepage': 'Homepage',
    'admin.breaking': 'Breaking news',
    'admin.live': 'Live coverage',
    'admin.taxonomy': 'Taxonomy',
    'admin.categories': 'Categories',
    'admin.districts': 'Districts',
    'admin.tags': 'Tags',
    'admin.authors': 'Authors',
    'admin.administration': 'Administration',
    'admin.users': 'Users',
    'admin.settings': 'Settings',
    'admin.auditLog': 'Audit log',
    'admin.quickCreate': 'Create',
    'admin.newArticle': 'New article',
    'admin.newBreaking': 'New breaking item',
    'admin.newVideo': 'New video',
    'admin.commandHint': 'Search or jump to…',
    'admin.commandPlaceholder': 'Type an article headline, or a screen',
    'admin.commandScreens': 'Screens',
    'admin.commandArticles': 'Articles',
    'admin.commandEmpty': 'Nothing matches that.',
    'admin.signedInAs': 'Signed in as',
    'admin.viewSite': 'View the site',
    'admin.logout': 'Log out',
    'admin.language': 'CMS language',
    'admin.greeting': 'Good to see you, {name}',
    'admin.statArticles': 'Articles',
    'admin.statPublishedToday': 'Published today',
    'admin.statDrafts': 'Drafts',
    'admin.statPendingReview': 'Pending review',
    'admin.statBreaking': 'Active breaking',
    'admin.statLive': 'Live events',
    'admin.statArticleViews': 'Article views',
    'admin.statVideoViews': 'Video views',
    'admin.statVideos': 'Videos published',
    'admin.statSubscribers': 'Subscribers',
    'admin.statCreatives': 'Active creatives',
    'admin.queueReview': 'Waiting for review',
    'admin.queueMine': 'Your desk',
    'admin.queueEmptyReview': 'Nothing is waiting for review.',
    'admin.queueEmptyMine': 'Nothing on your desk yet — start a story.',
    'admin.tickerNow': 'On the ticker now',
    'admin.tickerEmpty': 'Nothing is on the ticker.',
    'admin.untilExpiry': 'until {time}',
    'admin.noExpiry': 'no end time',
    'admin.searchTable': 'Search',
    'admin.columns': 'Columns',
    'admin.selected': '{count} selected',
    'admin.clearSelection': 'Clear',
    'admin.rowsPerPage': 'Rows',
    'admin.pageOf': 'Page {page} of {pages}',
    'admin.emptyTable': 'Nothing here yet.',
    'admin.errorTable': 'That did not load.',
    'admin.status.draft': 'Draft',
    'admin.status.pending_review': 'Pending review',
    'admin.status.approved': 'Approved',
    'admin.status.scheduled': 'Scheduled',
    'admin.status.published': 'Published',
    'admin.status.archived': 'Archived',
    'admin.colHeadline': 'Headline',
    'admin.colStatus': 'Status',
    'admin.colLanguage': 'Lang',
    'admin.colPublished': 'Published',
    'admin.colUpdated': 'Updated',
    'admin.colViews': 'Views',
    'admin.colTranslation': 'Translation',
    'admin.noTranslation': 'No translation',
    'admin.createTranslation': '+ Translate',
    'admin.publishedAt': 'Publication date & time',
    'admin.publishedAtHint': 'Set to adjust or backdate publication timestamp.',
    'admin.linkTranslation': 'Link existing article',
    'admin.unlinkTranslation': 'Unlink',
    'admin.unlinkTranslationConfirm': 'Are you sure you want to unlink this translation pair?',
    'admin.counterpartArticleId': 'Counterpart article ID',
    'admin.linkAction': 'Link translation',
    'admin.bulkPublish': 'Publish',
    'admin.bulkUnpublish': 'Unpublish',
    'admin.bulkArchive': 'Archive',
    'admin.bulkDelete': 'Delete',
    'admin.bulkResult': '{done} done, {failed} refused',
    'admin.confirmDelete': 'Delete {count} article(s)? They disappear from every screen.',
    'action.cancel': 'Cancel',
    'admin.byline': 'Byline',
    'admin.canonical': 'Canonical URL',
    'admin.category': 'Category',
    'admin.compare': 'Compare',
    'admin.conflictTitle': 'Someone else saved this story',
    'admin.conflictBody': 'Your text is still here. Copy anything you need, then reload to get their version.',
    'admin.createTag': 'Create “{name}”',
    'admin.currentSide': 'Now',
    'admin.diffHint': 'The editor above holds the current text — compare it with this revision.',
    'admin.district': 'District',
    'admin.editorPlaceholder': 'Start writing…',
    'admin.editorToolbar': 'Formatting',
    'admin.embed': 'Embed',
    'admin.embedPrompt': 'Paste a YouTube, X, Facebook or Instagram URL',
    'admin.embedNotAllowed': 'Embeds are only allowed from YouTube, X, Facebook, and Instagram.',
    'admin.editImageCaption': 'Alt & Caption',
    'admin.imageAltPrompt': 'Image alternative text (for accessibility and SEO):',
    'admin.imageCaptionPrompt': 'Image caption (optional):',
    'admin.articleVideo': 'Article Video',
    'admin.articleVideoHint': 'Optional YouTube video URL for this article.',
    'admin.clearVideo': 'Clear video',
    'admin.emptyRevision': 'This revision has no body.',
    'admin.headline': 'Headline',
    'admin.languageImmutable': 'Chosen once — a translation is a separate story (§1.15).',
    'admin.link': 'Link',
    'admin.linkPrompt': 'Link address (empty removes the link)',
    'admin.noActions': 'No action available to you on this story right now.',
    'admin.noRevisions': 'No revisions yet.',
    'admin.note': 'Note to the writer',
    'admin.noteRequired': 'Required — the writer sees this.',
    'admin.placement': 'Placement',
    'admin.preview': 'Preview',
    'admin.readingStats': '{words} words · {minutes} min read',
    'admin.reload': 'Reload',
    'admin.removeTag': 'Remove tag',
    'admin.rename': 'Rename',
    'admin.renameSlug': 'New slug',
    'admin.restore': 'Restore this revision',
    'admin.revisionDiff': 'Revision #{number}',
    'admin.revisionRestored': 'Revision restored.',
    'admin.revisionSide': 'Revision #{number}',
    'admin.revisions': 'Revisions',
    'admin.save': 'Save',
    'admin.saveConflict': 'Conflict',
    'admin.saved': 'Saved',
    'admin.savedAt': 'Saved {time}',
    'admin.saving': 'Saving…',
    'admin.scheduleFor': 'Publish at',
    'admin.seo': 'SEO & sharing',
    'admin.seoDescription': 'Meta description',
    'admin.seoDescriptionHint': 'Around 155 characters. Falls back to the summary.',
    'admin.seoTitle': 'SEO title',
    'admin.seoTitleHint': 'Falls back to the headline.',
    'admin.slug': 'Slug',
    'admin.slugChanged': 'Renamed — the old address now redirects.',
    'admin.slugHint': 'Latin script, even for an Assamese headline (§1.15).',
    'admin.slugLocked': 'Locked after publishing. Rename below to create a redirect.',
    'admin.startWriting': 'Start writing',
    'admin.subheadline': 'Subheadline',
    'admin.summary': 'Summary',
    'admin.table': 'Table',
    'admin.tagPlaceholder': 'Search or create a tag',
    'admin.unsaved': 'Unsaved changes',
    'admin.workflowDone': 'Now {status}.',
    'admin.action.submit': 'Submit for review',
    'admin.action.approve': 'Approve',
    'admin.action.reject': 'Reject',
    'admin.action.request_changes': 'Request changes',
    'admin.action.publish': 'Publish',
    'admin.action.schedule': 'Schedule',
    'admin.action.unpublish': 'Unpublish',
    'admin.action.archive': 'Archive',
    'admin.action.restore': 'Restore',
    'action.close': 'Close',
    'admin.addNew': 'Add new',
    'admin.addStory': 'Add a story',
    'admin.addStoryPlaceholder': 'Search published stories',
    'admin.addVideo': 'Add video',
    'admin.allTypes': 'All types',
    'admin.altMissing': 'Alt text missing — this image cannot be attached to a story',
    'admin.altRequired': 'Required before the image can be used in an article.',
    'admin.altText': 'Alt text',
    'admin.arrangementSaved': 'Front page updated.',
    'admin.autoRotate': 'Rotate automatically',
    'admin.breakingPublished': 'On the ticker.',
    'admin.caption': 'Caption',
    'admin.colour': 'Colour',
    'admin.confirmRotate': 'Rotate this image? The file is rewritten and every size regenerated.',
    'admin.create': 'Create',
    'admin.credit': 'Credit',
    'admin.culture': 'Culture feature',
    'admin.cultureSupport': 'Culture — supporting stories',
    'admin.edit': 'Edit',
    'admin.editingLanguage': 'Editing',
    'admin.expired': 'ended',
    'admin.externalUrl': 'Or an external link',
    'admin.hero': 'Hero carousel',
    'admin.icon': 'Icon',
    'admin.iconHint': 'A name from the icon set, e.g. sports, culture.',
    'admin.keyUpdate': 'Key update',
    'admin.linkStory': 'Link a story',
    'admin.livePreview': 'Live preview',
    'admin.mediaDeleteRefused': '{count} still in use and kept.',
    'admin.mediaDeleted': 'Deleted.',
    'admin.mediaSaved': 'Image details saved.',
    'admin.mediaTransformed': 'Image rewritten.',
    'admin.mediaType': 'Type',
    'admin.minutesLeft': '{minutes} min left',
    'admin.moveDown': 'Move down',
    'admin.moveUp': 'Move up',
    'admin.name': 'Name',
    'admin.newLiveEvent': 'New live event',
    'admin.newUpdate': 'New update',
    'admin.noPins': 'Nothing pinned — trending is computed.',
    'admin.pickEvent': 'Pick an event to post into.',
    'admin.post': 'Post',
    'admin.postShortcut': 'Ctrl/⌘ + Enter posts',
    'admin.priority': 'Priority',
    'admin.publishNow': 'Publish now',
    'admin.publishVideo': 'Publish',
    'admin.ranked': 'Ranked column',
    'admin.refresh': 'Refresh',
    'admin.remove': 'Remove',
    'admin.rotate': 'Rotate 90°',
    'admin.rotationSeconds': 'Seconds',
    'admin.runsForHint': 'The ticker drops it at that point without anyone clicking.',
    'admin.runsForMinutes': 'Runs for (minutes)',
    'admin.saveOrder': 'Save order',
    'admin.searchMedia': 'Search filenames and captions',
    'admin.sections': 'Sections',
    'admin.slotEmpty': 'Nothing here yet.',
    'admin.slugDerived': 'The address is derived from the English name and kept unique.',
    'admin.source': 'Source',
    'admin.statusChanged': 'Status changed.',
    'admin.takeDown': 'Take down',
    'admin.trendingHint': 'A pin outranks the computed score and is never overwritten by it.',
    'admin.trendingPins': 'Trending pins',
    'admin.typeDocument': 'Documents',
    'admin.typeImage': 'Images',
    'admin.unpublishVideo': 'Unpublish',
    'admin.usageHint': 'Deleting is refused while a story still uses this image.',
    'admin.videoAdded': 'Video added.',
    'admin.delete': 'Delete',
    'admin.inactive': 'Inactive',
    'admin.confirmDeleteTaxonomy': 'Are you sure you want to delete this item?',
    'admin.deleteTaxonomyTitle': 'Delete “{name}”?',
    'admin.deleteTaxonomyTagWarning': 'This tag will be permanently deleted and removed from all stories.',
    'admin.deleteTaxonomyCategoryWarning': 'This category will be deleted. Make sure no published stories rely on it.',
    'admin.deleteTaxonomyDistrictWarning': 'This district will be deleted.',
    'admin.deleteTaxonomyAuthorWarning': 'If this author has articles, they will be deactivated to preserve published bylines. If they have none, they will be deleted permanently.',
    'admin.filterTaxonomy': 'Filter by name or slug…',
    'admin.noMatchingTaxonomy': 'No items match your search.',
    'admin.clearFilter': 'Clear filter',
    'admin.itemDeleted': 'Item deleted.',
    'admin.authorDeactivated': 'Author deactivated (bylines preserved on existing articles).',
    'admin.authorReactivated': 'Author reactivated.',
    'admin.editVideo': 'Edit video',
    'admin.deleteVideo': 'Delete video',
    'admin.confirmDeleteVideo': 'Are you sure you want to delete this video? It will be removed from all feeds.',
    'admin.videoUpdated': 'Video updated.',
    'admin.videoDeleted': 'Video deleted.',
    'admin.videoDescription': 'Description',
    'admin.durationSeconds': 'Duration (seconds)',
    'admin.videoResolved': 'Recognised as {source} · {id}',
    'admin.videoTitle': 'Title',
    'admin.videoUrl': 'Video URL',
    'admin.viewLive': 'View live page',
    'admin.topStory': 'Top story',
    'admin.topStoryBadge': 'Top',
    'admin.makeTopStory': 'Make top',
    'admin.topStoryHint': 'Leads the front page in this language. Setting it here demotes the story that holds it now.',
    'admin.topStoryWhenPublished': 'It will lead the front page as soon as this story is published.',
    'admin.topStorySet': 'Now leading the front page.',
    'admin.topStoryCleared': 'No longer the top story.',
    'admin.featuredImage': 'Lead image',
    'admin.chooseImage': 'Choose an image',
    'admin.replaceImage': 'Replace',
    'admin.removeImage': 'Remove',
    'admin.insertImage': 'Image',
    'admin.upload': 'Upload',
    'admin.uploadDone': 'Uploaded.',
    'admin.uploadFailed': '{count} could not be uploaded.',
    'admin.mediaEmpty': 'No images yet — upload one or drop it here.',
    'admin.useImage': 'Use this image',
    'admin.saveAltText': 'Save alt text',
    'admin.chooseSocialImage': 'Choose a share image',
    'admin.replaceSocialImage': 'Replace share image',
    'admin.useFeaturedImage': 'Use the lead image',
    'admin.section.top_story': 'Top story',
    'admin.section.hero': 'Hero',
    'admin.section.ranked': 'Ranked',
    'admin.section.categories': 'Categories',
    'admin.section.latest': 'Latest',
    'admin.section.trending': 'Trending',
    'admin.section.culture': 'Culture',
    'admin.section.live': 'Live',
    'admin.section.videos': 'Videos',
    'admin.section.newsletter': 'Newsletter',
    'admin.section.ad': 'Advertisement',
    'admin.breakingStatus.scheduled': 'Scheduled',
    'admin.breakingStatus.active': 'Live',
    'admin.breakingStatus.expired': 'Ended',
    'admin.breakingStatus.archived': 'Archived',
    'admin.liveStatus.scheduled': 'Scheduled',
    'admin.liveStatus.live': 'Live',
    'admin.liveStatus.ended': 'Ended',
    'admin.liveStatus.archived': 'Archived',
    'admin.role': 'Role',
    'admin.roleMatrix': 'Roles and permissions',
    'admin.roleMatrixHint': 'Read-only: the map lives in code (§1.4), and the database mirrors it.',
    'admin.permission': 'Permission',
    'admin.newUser': 'New user',
    'admin.userCreated': 'Account created. Hand over the temporary password.',
    'admin.temporaryPassword': 'Temporary password',
    'admin.temporaryPasswordHint': 'At least 12 characters. They must change it at first login.',
    'admin.forceReset': 'Force reset',
    'admin.forceResetBody': 'Every session ends immediately and they must set a new password at login.',
    'admin.resetDone': 'Password reset and sessions ended.',
    'admin.revokeSessions': 'End sessions',
    'admin.sessionsRevoked': 'Sessions ended.',
    'admin.sessions': 'Sessions',
    'admin.lastLogin': 'Last login',
    'admin.deactivate': 'Deactivate',
    'admin.reactivate': 'Reactivate',
    'admin.confirmDeactivate': 'Deactivate this account? Their sessions end immediately.',
    'admin.userStatus.active': 'Active',
    'admin.userStatus.invited': 'Invited',
    'admin.userStatus.suspended': 'Suspended',
    'admin.userStatus.deactivated': 'Deactivated',
    'admin.myProfile': 'My profile',
    'admin.profileSubtitle': 'Manage your personal details, email address, and account security.',
    'admin.editUser': 'Edit user',
    'admin.editUserSubtitle': 'Update account details, role, status, or set a new password.',
    'admin.changePassword': 'Change password',
    'admin.currentPassword': 'Current password',
    'admin.newPassword': 'New password',
    'admin.confirmNewPassword': 'Confirm new password',
    'admin.passwordMismatch': 'New passwords do not match',
    'admin.passwordMinLength': 'Password must be at least 8 characters',
    'admin.profileUpdated': 'Profile updated.',
    'admin.passwordChanged': 'Password changed successfully.',
    'admin.userUpdated': 'User updated successfully.',
    'admin.setPasswordHint': 'Leave empty to keep existing password, or enter at least 8 characters',
    'admin.activeSessions': 'Active sessions',
    'admin.preferredLanguage': 'Preferred language',
    'admin.accountSecurity': 'Account security',
    'admin.siteSettings': 'Site',
    'admin.seoSettings': 'SEO defaults',
    'admin.defaultTitle': 'Default title',
    'admin.titleTemplate': 'Title template',
    'admin.titleTemplateHint': 'e.g. {title} — NK News Time',
    'admin.defaultDescription': 'Default description',
    'admin.organisation': 'Organisation name',
    'admin.twitterSite': 'X / Twitter handle',
    'admin.robots': 'Robots directives',
    'admin.robotsHint': 'e.g. index, follow — Phase 15 writes this into every page.',
    'admin.googleVerification': 'Google verification',
    'admin.bingVerification': 'Bing verification',
    'admin.when': 'When',
    'admin.actor': 'Who',
    'admin.actionColumn': 'Action',
    'admin.actionPrefix': 'article. …',
    'admin.entity': 'Subject',
    'admin.allEntities': 'Everything',
    'meta.searchDescription': 'Search every story NK News Time has published, in Assamese and English — by category, district, author or date.',
    'meta.trendingDescription': 'The stories Assam is reading right now, ranked by what readers actually open, finish and share.',
    'meta.videosDescription': 'Ground reports, interviews and bulletins from across Assam — the NK News Time video desk.',
    'meta.liveDescription': 'Live coverage from NK News Time: assembly sessions, election counts, floods and everything else that changes by the minute.',
    'meta.newsletterDescription': 'The day in Assam, in your inbox. A free daily briefing from the NK News Time newsroom.',
    'meta.localDescription': 'District news from across Assam — reported locally, by reporters who live there.',
    'meta.categoryDescription': '{name} news from Assam and beyond, reported by NK News Time.',
    'meta.tagDescription': 'Every NK News Time story tagged {name}, newest first.',
    'meta.authorDescription': 'Stories by {name} for NK News Time.',
    // --- Measurement notice (Phase 16) -----------------------------------------
    'consent.title': 'Measurement',
    'consent.body': 'We count what is read so the newsroom knows which stories matter. No cookies, no advertising trackers, and nothing that identifies you.',
    'consent.accept': 'Allow',
    'consent.decline': 'No thanks',
    // --- Analytics (PRD §25) ----------------------------------------------------
    'admin.analytics': 'Analytics',
    'admin.analytics.overview': 'Overview',
    'admin.analytics.content': 'Content',
    'admin.analytics.video': 'Video',
    'admin.analytics.advertising': 'Advertising',
    'admin.analytics.search': 'Search',
    'admin.analytics.visitors': 'Visitors',
    'admin.analytics.visitorsHint': 'Counted fresh each day. Somebody who returns tomorrow counts twice — the identifier rotates nightly and is never kept from one day to the next.',
    'admin.analytics.sessions': 'Sessions',
    'admin.analytics.pageViews': 'Page views',
    'admin.analytics.pagesPerSession': 'Pages per session',
    'admin.analytics.trend': 'Visitors and page views',
    'admin.analytics.sources': 'Traffic sources',
    'admin.analytics.devices': 'Devices',
    'admin.analytics.countries': 'Countries',
    'admin.analytics.topPages': 'Popular pages',
    'admin.analytics.articleViews': 'Article views',
    'admin.analytics.avgReadTime': 'Average reading time',
    'admin.analytics.shares': 'Shares',
    'admin.analytics.mostRead': 'Most read',
    'admin.analytics.mostShared': 'Most shared',
    'admin.analytics.popularCategories': 'Popular categories',
    'admin.analytics.popularDistricts': 'Popular districts',
    'admin.analytics.finished': 'Finished',
    'admin.analytics.plays': 'Plays',
    'admin.analytics.watchTime': 'Watch time',
    'admin.analytics.completionRate': 'Completion rate',
    'admin.analytics.impressions': 'Impressions',
    'admin.analytics.clicks': 'Clicks',
    'admin.analytics.ctr': 'CTR',
    'admin.analytics.campaigns': 'By campaign',
    'admin.analytics.placements': 'By placement',
    'admin.analytics.adsPending': 'Creatives are served from Phase 13. Until then these figures are correct and empty.',
    'admin.analytics.searches': 'Searches',
    'admin.analytics.zeroResultRate': 'Found nothing',
    'admin.analytics.topQueries': 'Top queries',
    'admin.analytics.zeroQueries': 'Queries that found nothing',
    'admin.analytics.zeroQueriesHint': 'What readers looked for and did not find — the clearest signal of a gap in the coverage.',
    'admin.analytics.query': 'Query',
    'admin.analytics.avgResults': 'Average results',
    'admin.analytics.timesSearched': 'Searched',
    'admin.analytics.range7': 'Last 7 days',
    'admin.analytics.range28': 'Last 28 days',
    'admin.analytics.range90': 'Last 90 days',
    'admin.analytics.rangeCustom': 'Custom',
    'admin.analytics.from': 'From',
    'admin.analytics.to': 'To',
    'admin.analytics.compare': 'Compare with the period before',
    'admin.analytics.comparedWith': 'vs {value} before',
    'admin.analytics.exportCsv': 'Export CSV',
    'admin.analytics.allLanguages': 'Both editions',
    'admin.analytics.noData': 'Nothing recorded in this period yet.',
    'admin.analytics.freshness': 'Figures refresh every ten minutes.',
    'admin.analytics.device.mobile': 'Mobile',
    'admin.analytics.device.tablet': 'Tablet',
    'admin.analytics.device.desktop': 'Desktop',
    'admin.analytics.direct': 'Direct',
    'admin.analytics.unknown': 'Unknown',
    'admin.analytics.page': 'Page',
    'admin.analytics.views': 'Views',
    'admin.analytics.headline': 'Headline',
    'admin.analytics.videoTitle': 'Video',
    'admin.analytics.campaign': 'Campaign',
    'admin.analytics.placement': 'Placement',
    'admin.analytics.shareOfTotal': 'Share',
    'admin.analytics.seconds': '{value}s',
};
//# sourceMappingURL=en.js.map